import axios from "axios";
import config from "@/config/env.config.json";
import logger from "@/utils/logger";

const envConfig = config[process.env.NODE_ENV];
const consumerBaseUrl = envConfig.consumerApiBaseUrl;
const specialtyApi = {};

specialtyApi.getSpecialties = async () => {
  try {
    const response = await axios.get(`${consumerBaseUrl}/practice_specialties`);
    logger.info("specialties api", response.data);
    return response.data;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

export default specialtyApi;
